module.exports = __webpack_public_path__ + "img/bold.3bcc3ecf.svg";